/* eslint-disable global-require */
import React from 'react';
import _ from 'lodash';
import styles from './css/ResourcesBlock.styl';
import {RightFollowLink} from '../../../../shared/Svgs';

/**
 * The ResourcesBlock item on the person page
 * @param   {Object}  props - passed down props
 * @return  {JSX}     Returns a block of resource links
 */
const ResourcesBlock = props =>
  _.isEmpty(props.resources) ? null : (
    <aside className={styles.ResourcesBlock}>
      <h2 className={styles.header}>{props.title}</h2>
      <div className={styles.itemGroup}>
        {props.resources.map((resource, index) => {
          const img = require(`./assets/${resource.asset}`);

          return (
            <div className={styles.item} key={index}>
              <a href={resource.url} target={resource.target}>
                <div className={styles.ResourceLeft}>
                  <img src={img} />
                </div>
                <div className={styles.ResourceRight}>
                  <p className={styles.text}>{resource.text}</p>
                </div>
                <div className={styles.icon}>
                  <RightFollowLink />
                </div>
              </a>
            </div>
          );
        })}
      </div>
    </aside>
  );

ResourcesBlock.propTypes = {
  resources: React.PropTypes.array,
  title: React.PropTypes.string,
};

export default ResourcesBlock;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Person/components/ResourcesBlock/ResourcesBlock.js